var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFound_pg-container"},[_c('el-image',{staticStyle:{"width":"310px","height":"264px"},attrs:{"src":_vm.notFoundImg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }